<template>
  <n-config-provider v-bind="langConfig" :theme-overrides="theme" abstract>
    <n-message-provider placement="bottom">
      <NuxtLoadingIndicator :height="4" :color="colors.yellow['50']" />
      <NuxtLayout>
        <NuxtPage />
        <full-page-loading />
        <lang-switcher />
        <cs-bubble v-if="isCsBubbleShown" :has-unread-messages="hasUnreadMessages" @click="handleOpen" />
      </NuxtLayout>
    </n-message-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import { NConfigProvider, NMessageProvider } from 'naive-ui'

import { colors } from '@/theme.config'
import theme from '@/naive-ui-theme'

import FullPageLoading from '@/components/common/full-page-loading.vue'
import LangSwitcher from '@/components/common/lang-switcher.vue'

import { useNUILocale } from '@/composables/useIntl'
import { useAppStore } from '@/store/app'

const CsBubble = defineAsyncComponent(() => import('@/components/common/cs-bubble.vue'))

const appStore = useAppStore()
const { showFullPageLoading } = storeToRefs(appStore)

const { isCsBubbleShown, hasUnreadMessages, initialCs, handleOpen } = useCustomerService()
const { isLocaleMessageLoading } = useLocaleMessages()

useNicedaySeoSetting()
useSentryRegister()

const { nUILocale, nUIDateLocale } = useNUILocale()
const langConfig = computed(() => ({ locale: nUILocale.value, dateLocale: nUIDateLocale.value }))

onMounted(() => {
  initialCs()
})

watch(isLocaleMessageLoading, newIsLocaleMessageLoading => {
  showFullPageLoading.value = newIsLocaleMessageLoading
})
</script>

<style lang="scss" src="@/assets/styles/naive-ui-overrides.scss" scoped></style>
<style lang="scss"></style>
